export const dataMap = {
    computed: {
        sourceMap(){
            return new Map([
                [1, '秀动'],
                [2, '有演出'],
                [3, '微博'],
                [4, 'QQ'],
                [5, '豆瓣'],
                [6, '微信'],
                [7, 'Zaker'],
                [8, '订单分享带朋友'],
                [9, '百度'],
                [10, '糯米'],
                [11, '百度音乐人'],
                [12, '网易云音乐'],
                [13, 'QQ音乐'],
                [14, '文客'],
                [15, '大麦'],
                [16, '秀动赠票']
            ])
        },
        terminalMap(){
            return new Map([
                [1, 'WEB'],
                [2, 'WAPCN'],
                [3, 'iOS'],
                [4, 'Android'],
                [5, 'WAPEN'],
                [6, '微信小程序'],
                [7, '抖音小程序'],
                [9, '管理后台'],
                [10, '经营平台'],
				[12, '支付宝小程序'],
                [13, '小红书小程序'],
                [14, '鸿蒙']
            ]) 
        }
    }
}